import React, { useState, useRef } from "react";
import Classes from "./Branding.module.css";
import { useSelector } from "react-redux";
import convertToRgba from "../../../../../../../utils/colorUtils";

const TickSvg = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 448 512"><path fill="white" d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z" /></svg>
)

const Branding = () => {
    let companyInfo = useSelector((state) => state.companyInfo?.info);
    companyInfo.color = "#3e9bff";
    const [isEditing, setIsEditing] = useState(false);
    const [colorScheme, setcolorScheme] = useState(companyInfo?.color);
    const [imageURL, setImageURL] = useState(companyInfo?.logo);
    const [brochureLoading, setBrochureLoading] = useState(false);
    const [companyName, setcompanyName] = useState(companyInfo?.companyName);

    const imageInputRef = useRef(null);

    const handleClick = () => {
        if (imageInputRef.current) {
            imageInputRef.current.click();
        }
    };

    const handleInputChange = (e) => {
        const files = e.target.files;
        const name = e.target.name;
        // handleFileChange(files, name);
    };

    return (
        <div className={Classes.container}>

            <div className={Classes.infoSection}>
                <div className={Classes.box2Header} >
                    <h3>Dashboard branding</h3>
                </div>

                <div className={Classes.boxCon} >
                    <h5 className={Classes.label} >Color scheme</h5>
                    <div className={Classes.textAlign} >
                        <input
                            type='color'
                            value={colorScheme}
                            onChange={(e) => setcolorScheme(e.target.value)}
                        />
                        <input
                            type='text'
                            value={colorScheme}
                            onChange={(e) => { setcolorScheme(e.target.value); }}
                            className={Classes.colorSchemeTextInput}
                        />
                        <button className={Classes.confirmBtn} style={{ background: companyInfo?.color }}>
                            <TickSvg height="14px" width="14px" />
                            <h5>Confirm</h5>
                        </button>
                    </div>
                </div>

                <div className={Classes.boxCon} >
                    <h5 className={Classes.label} >Logo</h5>
                    <div className={Classes.textAlign} >
                        <div
                            className={Classes.uploadCon}
                            onClick={handleClick}
                            style={{ border: `1px solid ${companyInfo?.color}` }}
                        >
                            <input
                                ref={imageInputRef}
                                hidden
                                accept="image/*"
                                type="file"
                                onChange={handleInputChange}
                                name="uploadBrochure"
                                id="formFile" />
                            <svg height="20px" fill={companyInfo?.color} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
                                <path d="M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM216 408c0 13.3-10.7 24-24 24s-24-10.7-24-24V305.9l-31 31c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l72-72c9.4-9.4 24.6-9.4 33.9 0l72 72c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-31-31V408z" />
                            </svg>
                        </div>
                        {
                            brochureLoading ? <h5>Loading...</h5> : null
                        }

                        {/* {imageURL && (
                            <img
                                style={{ height: "3rem", width: 'max-content', margin: "3px", borderRadius: "6px" }}
                                src={imageURL}
                                alt="Uploaded Image"
                            />
                        )} */}
                    </div>
                </div>

                <div className={Classes.boxCon} >
                    <h5 className={Classes.label} >Landing Page Link</h5>
                    <div className={Classes.textAlign} >
                        <div className={`${Classes.passwordCon}`}  >
                            <input
                                onChange={(e) => { setcompanyName(e.target.value) }}
                                type="text"
                                placeholder="Account Name"
                                value={companyName}
                                required
                            />
                            <div className={Classes.preDomain} style={{ background: convertToRgba(companyInfo?.color, 0.2) }} > <h5>.anchorize.io</h5> </div>
                        </div>
                        <button className={Classes.confirmBtn} style={{ background: companyInfo?.color }}>
                            <TickSvg height="14px" width="14px" />
                            <h5>Confirm</h5>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Branding;
